import React from 'react'
import clsx from 'clsx'

import Tooltip from '../../../../../components/atoms/Tooltip'

import useStyles from './styles'

const StatusDot = ({ online = false, className = undefined }) => {
  const classes = useStyles({ online })

  return (
    <div className={clsx(classes.root, className)}>
      <Tooltip
        title={`Currently ${online ? 'online' : 'offline'}`}
        arrow
        placement='right'
      >
        <div className={classes.dot} />
      </Tooltip>
    </div>
  )
}

export default StatusDot
